import { Button, Text } from 'components/@tedui';
import Modal, { ModalType } from 'components/modal';

interface Props {
  isOpen: boolean;
  onDismiss: () => void;
  showButtons: boolean;
}

function SignInModal({
  isOpen,
  onDismiss,
  showButtons
}: Props): React.ReactNode {
  return (
    <Modal
      type={ModalType.Medium}
      isOpen={isOpen}
      onDismiss={onDismiss}
      ariaLabel="Sign in or create an account to comment or reply."
      noOverflow
      modalClassName="max-w-screen-sm-tui !min-h-max !pb-16 md:!pb-32"
    >
      <section className="md:pt-11">
        <Text variant="header2" tag="h2" isBold>
          Account Required
        </Text>

        <div className="mx-auto mt-10 flex max-w-[26.5rem] flex-col gap-[1.375rem] text-center md:gap-10 lg:mt-20">
          <Text tag="p">
            To post a comment or a reply, you must be signed into a TED account.
          </Text>

          {showButtons && (
            <div className="flex gap-4 md:gap-5">
              <a
                rel="noreferrer"
                className="w-full flex-1"
                href={`https://auth.ted.com/session/new?referrer=${window.location.href}`}
              >
                <Button text="Sign in" />
              </a>

              <a
                rel="noreferrer"
                className="w-full flex-1"
                href={`https://auth.ted.com/users/new?referrer=${window.location.href}`}
              >
                <Button variant="secondary" text="Create Account" />
              </a>
            </div>
          )}
        </div>
      </section>
    </Modal>
  );
}

export default SignInModal;
